import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { eLoaiChungChiDanhSachMonActionIds, ILoaiChungChiDanhSachMonActionTypes } from "../../action-types/chuong-trinh-dao-tao/ILoaiChungChiDanhSachMonActions";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { rootActions } from "../../actions/rootActions";
import { loaiChungChiDanhSachMonApi } from "../../../api/chuong-trinh-dao-tao/loaiChungChiDanhSachMonApi";
import { ILoaiChungChiDanhSachMonSysRequest } from "../../../model/request/chuong-trinh-dao-tao/IloaiChungChiDanhSachMonSysRequest";

export function* loaiChungChiDanhSachMonSaga() {
    yield takeLatest(eLoaiChungChiDanhSachMonActionIds.LOAD_START, loadWorker);
    yield takeEvery(eLoaiChungChiDanhSachMonActionIds.SYS_START, sysWorker);
}

function* loadWorker() : any {
    const res: IBaseResponse = yield call(loaiChungChiDanhSachMonApi.SelectAll);
    if (res.is_success) {
        yield put(rootActions.chuongTrinhDaoTaoWrapper.loaiChungChiDanhSachMon.LOAD_SUCCESS(res.data));
    } else {
        yield put(rootActions.chuongTrinhDaoTaoWrapper.loaiChungChiDanhSachMon.LOAD_ERROR(res.message ?? "Có lỗi"));
    }
}

function* sysWorker(action: ILoaiChungChiDanhSachMonActionTypes) : any {
    const request = action.payload as ILoaiChungChiDanhSachMonSysRequest;
    const res: IBaseResponse = yield call(loaiChungChiDanhSachMonApi.Sys, request);
    if (res.is_success) {
        yield put(rootActions.chuongTrinhDaoTaoWrapper.loaiChungChiDanhSachMon.SYS_SUCCESS(undefined));
    } else {
        yield put(rootActions.chuongTrinhDaoTaoWrapper.loaiChungChiDanhSachMon.SYS_ERROR(res.message ?? "Có lỗi"));
    }
}